import {
    ADD_CITY,
    GET_CITIES,
    GET_CITY,
    UPDATE_CITY,
    DELETE_CITY,
  } from "../types";
  
  const initialState = { list: [], single: null,
    pagination: {
      limit: 10,
      nextPage: null, 
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
    }, totalCount: 0 };
  
  const reducer = (state = initialState, action) => {
    const { type, payload, totalCount } = action;
  
    switch (type) {
      case GET_CITIES:
        return { ...state, list: payload.data, totalCount: totalCount , pagination: payload.pagination };
  
      case GET_CITY:
        return { ...state, single: payload || initialState.single };
  
      case UPDATE_CITY:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_CITY:
        return {
          ...state,
          list: [payload, ...state.list],
          totalCount: state.totalCount + 1
        };
  
      case DELETE_CITY:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
          totalCount: state.totalCount - 1
        };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  